import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  list: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingRight: ({ spacing }) => spacing(8),
  },

  listItem: {
    paddingLeft: ({ spacing }) => spacing(3),
    borderRadius: "0 20px 20px 0",
    position: "relative",

    "&.active": {
      backgroundColor: "primary.main",

      "&::before": {
        content: "''",
        position: "absolute",
        backgroundColor: "transparent",
        bottom: "-50px",
        height: "50px",
        width: "25px",
        left: 0,
        borderTopLeftRadius: "25px",
        boxShadow: ({ palette }) => `0 -25px 0 0 ${palette.primary.main}`,
      },

      "&::after": {
        content: "''",
        position: "absolute",
        backgroundColor: "transparent",
        top: "0",
        height: "50px",
        width: "25px",
        left: 0,
        borderBottomLeftRadius: "25px",
        boxShadow: ({ palette }) => `0 25px 0 0 ${palette.primary.main}`,
        transform: "translateY(-100%)",
      },

      ".MuiSvgIcon-root": {
        color: "#ffffff",
      },
    },
  },
};
